import { render, staticRenderFns } from "./AwardManagement.vue?vue&type=template&id=51c6ccd8"
import script from "./AwardManagement.vue?vue&type=script&lang=js"
export * from "./AwardManagement.vue?vue&type=script&lang=js"
import style0 from "./AwardManagement.vue?vue&type=style&index=0&id=51c6ccd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports